var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "management-workspace-map",
        "elevation-1",
        { "npv-class": _vm.isNpv }
      ],
      attrs: { id: "map", type: "light", oncontextmenu: "return false" }
    },
    [
      !_vm.drawPolygon
        ? _c("change-map-type-button", {
            staticStyle: { margin: "85px 0 0 10px" },
            attrs: { viewIsAerial: _vm.isAerial },
            on: { click: _vm.changeViewType }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.drawPolygon
        ? [
            _c(
              "div",
              { staticClass: "map-buttons" },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "ma-0 mb-2",
                    staticStyle: { width: "120px" },
                    attrs: { small: "", color: "accent" },
                    on: {
                      click: function($event) {
                        _vm.dialog = true
                      }
                    }
                  },
                  [
                    _c("v-icon", { attrs: { left: "" } }, [_vm._v("upload")]),
                    _vm._v(" "),
                    _c("span", { staticStyle: { "text-transform": "none" } }, [
                      _vm._v(_vm._s(_vm.$t("UploadFile")))
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "ma-0 mb-2",
                    class: { aerial: _vm.isAerial },
                    staticStyle: { width: "120px" },
                    attrs: {
                      disabled: !_vm.featureIsDrawn,
                      small: "",
                      color: "accent"
                    },
                    on: { click: _vm.resetPolygon }
                  },
                  [
                    _c("v-icon", { attrs: { left: "" } }, [_vm._v("replay")]),
                    _vm._v(" "),
                    _c("span", { staticStyle: { "text-transform": "none" } }, [
                      _vm._v(_vm._s(_vm.$t("StartOver")))
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "ma-0",
                    staticStyle: { width: "120px" },
                    attrs: { small: "", color: "accent" },
                    on: { click: _vm.showCoordinatesDialog }
                  },
                  [
                    _c("v-icon", { staticClass: "ml-1", attrs: { left: "" } }, [
                      _vm._v("place")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticStyle: { "text-transform": "none" } }, [
                      _vm._v(_vm._s(_vm.$tc("Coordinate", 2)))
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.viewAllWorkspaces
              ? _c(
                  "v-btn",
                  {
                    staticClass: "ma-0 all-workspaces-button",
                    attrs: {
                      loading: _vm.allWorkspacesLoading,
                      small: "",
                      color: "accent"
                    },
                    on: { click: _vm.toggleAllWorkspaces }
                  },
                  [
                    _c("v-checkbox", {
                      staticStyle: { "padding-top": "10px" },
                      attrs: {
                        "input-value": _vm.showAllWorkspaces,
                        left: "",
                        color: "white"
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticStyle: { "text-transform": "none" } }, [
                      _vm._v(_vm._s(_vm.$t("ViewAllWorkspaces")))
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("center-workspace-button", {
              attrs: {
                disabled: !_vm.workspaceFeature,
                viewIsAerial: _vm.isAerial
              },
              on: { click: _vm.centerOnWorkspace }
            }),
            _vm._v(" "),
            _c("change-map-type-button", {
              attrs: { viewIsAerial: _vm.isAerial },
              on: { click: _vm.changeViewType }
            }),
            _vm._v(" "),
            _c(
              "v-dialog",
              {
                attrs: { width: "400", persistent: "" },
                model: {
                  value: _vm.dialog,
                  callback: function($$v) {
                    _vm.dialog = $$v
                  },
                  expression: "dialog"
                }
              },
              [
                _c(
                  "v-card",
                  { staticClass: "delete-modal" },
                  [
                    _c("v-card-title", { staticClass: "headline" }, [
                      _vm._v(_vm._s(_vm.$t("UploadFile")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-card-text",
                      [
                        _c(
                          "v-layout",
                          { attrs: { column: "" } },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "input-field-container",
                                staticStyle: { "margin-bottom": "10px" }
                              },
                              [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$tc("Type", 1)))
                                ]),
                                _vm._v(" "),
                                _c("treeselect", {
                                  attrs: {
                                    options: _vm.typeSelectOptions,
                                    placeholder: null,
                                    searchable: false
                                  },
                                  model: {
                                    value: _vm.typeSelect,
                                    callback: function($$v) {
                                      _vm.typeSelect = $$v
                                    },
                                    expression: "typeSelect"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "input-field-container" },
                              [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$tc("Projection", 1)))
                                ]),
                                _vm._v(" "),
                                _c("treeselect", {
                                  attrs: {
                                    options: _vm.projectionOptions,
                                    "load-options": _vm.loadProjections,
                                    placeholder: null,
                                    disableFuzzyMatching: ""
                                  },
                                  model: {
                                    value: _vm.projection,
                                    callback: function($$v) {
                                      _vm.projection = $$v
                                    },
                                    expression: "projection"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("drop-file-area", {
                              ref: "dropFileArea",
                              staticStyle: { "padding-top": "20px" },
                              attrs: {
                                "file-types": _vm.acceptedFileTypes,
                                disabled: !_vm.fileSelectionEnabled
                              },
                              on: {
                                updateFile: function($event) {
                                  _vm.dropzoneFile = $event
                                },
                                trashFile: function($event) {
                                  _vm.dropzoneFile = null
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-card-actions",
                      { staticStyle: { padding: "8px" } },
                      [
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c("management-button", {
                          attrs: { type: "cancel", label: _vm.$t("Cancel") },
                          on: { buttonClick: _vm.cancelForm }
                        }),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticClass: "text-capitalize",
                            staticStyle: {
                              "font-size": "12px",
                              padding: "16px 29px",
                              "border-radius": "4px"
                            },
                            attrs: {
                              small: "",
                              color: "accent",
                              disabled: !_vm.buttonActive,
                              loading: _vm.loading
                            },
                            on: { click: _vm.submitForm }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("Submit")) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("workspace-coordinates", {
              attrs: {
                coordinatesDialog: _vm.coordinatesDialog,
                coordinates: _vm.coordinates
              },
              on: {
                "close-coordinates-dialog": _vm.closeCoordinatesDialog,
                "center-on-coordinates": _vm.centerOnCoordinates
              }
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ba186db6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba186db6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectManagement/Workspaces/WorkspaceMap.vue
// module id = null
// module chunks = 